import { Box, Paper, Typography } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";

function NoLicenseScreen({
  clientColor = "#1565C0",
  title = "No Licenses Available",
  message = "Not enough available licenses.",
  organizationName = "",
  helperText = "Please contact your administrator to add or reassign licenses."
}) {
  const accentColor = clientColor || "#1565C0";

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "#F4F6F8",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2
      }}>
      <Paper
        elevation={0}
        sx={{
          p: 5,
          maxWidth: 460,
          width: "100%",
          textAlign: "center",
          background: "white",
          borderRadius: 3,
          border: "1px solid #E0E0E0",
          boxShadow: "0 4px 20px rgba(0,0,0,0.05)"
        }}>
        <Box
          sx={{
            width: 72,
            height: 72,
            margin: "0 auto 24px",
            background: `${accentColor}1A`,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: accentColor
          }}>
          <LockIcon sx={{ fontSize: 36 }} />
        </Box>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            mb: 1,
            color: "#1a202c"
          }}>
          {title}
        </Typography>
        <Typography  sx={{color: "text.secondary",  mt: 1, lineHeight: 1.6 }}>
          {message}
        </Typography>
        {organizationName ? (
          <Typography  sx={{color: "text.secondary",  mt: 1, lineHeight: 1.6 }}>
            Please contact{" "}
            <Box component="span" sx={{ color: accentColor, fontWeight: 700 }}>
              {organizationName}
            </Box>
            .
          </Typography>
        ) : (
          <Typography  sx={{color: "text.secondary",  mt: 1, lineHeight: 1.6 }}>
            {helperText}
          </Typography>
        )}
      </Paper>
    </Box>
  );
}

export default NoLicenseScreen;
